export default __webpack_public_path__ + "static/media/adminbg.e2955d39.jpg";